interface DashboardHeaderProps {
  user: any;
  currentLang: "ro" | "en";
}

export function DashboardHeader({
  user: _user,
}: DashboardHeaderProps) {
  return (
    <>
      <div className="flex items-center justify-between h-8">
        <div className="flex items-center">
          <img 
            src="/suuper_logo.svg" 
            alt="Suuper" 
            className="h-6 w-auto "
          />
        </div>
      </div>
    </>
  );
}
